export enum TInsuranceCompaniesType {
  INSURANCE = "insurance",
  GUARANTOR = "guarantor",
}

export const getInsuranceCompanyTypeLabel = (
  type: TInsuranceCompaniesType,
  t: (key: string) => string
): string => {
  const typeLabels = {
    [TInsuranceCompaniesType.INSURANCE]: t(
      "insuranceCompanies.form.fields.type.insurance"
    ),
    [TInsuranceCompaniesType.GUARANTOR]: t(
      "insuranceCompanies.form.fields.type.guarantor"
    ),
  };
  return typeLabels[type];
};

export const getInsuranceCompanyTypeOptions = (t: (key: string) => string) => [
  {
    value: TInsuranceCompaniesType.INSURANCE,
    label: t("insuranceCompanies.form.fields.type.insurance"),
  },
  {
    value: TInsuranceCompaniesType.GUARANTOR,
    label: t("insuranceCompanies.form.fields.type.guarantor"),
  },
];

export type TInsuranceCompanies = {
  id?: string;
  name: string;
  cnpj: string;
  corporate_name: string;
  type: TInsuranceCompaniesType;
  created_at?: string;
};
